<!--
 * @Author: wangjx
 * @LastEditors: yingna.gao
 * @Date: 2022-02-17 10:54:31
 * @LastEditTime: 2022-09-09 15:32:48
 * @Description: file content
-->
<template>
  <div v-if="['basic', 'advance'].includes(mode)" class="search-form-wrapper">
    <!-- 基础版搜索 -->
    <div v-if="mode === 'basic'" class="search-form-basic">
      <div class="basic-content">
        <span v-if="title" class="vertical-bar fn18 fnM">{{ title }}</span>
        <el-input
          v-if="basic.placeholder || searchPlaceholder"
          v-model="searchValue"
          class="searchInput"
          :placeholder="basic.placeholder || searchPlaceholder"
          clearable
          @keyup.enter.native="handleSearch"
        >
          <i slot="suffix" class="el-icon-search" @click="handleSearch"></i>
        </el-input>
      </div>
      <div class="basic-diff">
        <slot name="operations"></slot>
      </div>
    </div>

    <!-- 高级搜索 -->
    <div v-if="mode === 'advance'" class="search-form-advance">
      <search-form :form-options="formOptions" v-on="$listeners"></search-form>
    </div>
  </div>
</template>

<script>
import SearchForm from "@/components/common/SearchForm/index.vue";
export default {
  name: "TableSearchForm",
  components: { SearchForm },
  props: {
    mode: String,
    basic: Object,
    advanced: Object,
    title: String,
    searchPlaceholder: String,
    formOptions: Object
  },
  data() {
    return {
      searchValue: ""
    };
  },
  watch: {
    "basic.value": {
      immediate: true,
      handler(newValue) {
        this.searchValue = newValue;
      }
    },
    searchValue(newVal, oldVal) {
      if (!newVal && oldVal) {
        this.$emit("search", this.searchValue);
      }
    }
  },
  methods: {
    // 搜索
    handleSearch() {
      this.$emit("search", this.searchValue);
    }
  }
};
</script>

<style lang="scss" scoped>
.hidden {
  display: none;
}

.search-form-basic {
  padding: 12px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .el-icon-search {
    cursor: pointer;
  }
}

.basic-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;

  ::v-deep .el-input {
    width: 320px;
  }
}
</style>
